import { action, ActionType } from "typesafe-actions";
import { AxiosResponse } from "axios";

import { IError } from "../../../../redux/actions/errorHandlingAction";

export enum FileDownloadActions {
  Download = "FileDownload/Download",
  DownloadFailure = "FileDownload/DownloadFailure",
  DownloadSuccess = "FileDownload/DownloadSuccess",
}

export const download = (
  url: string,
  fallbackName: string,
  authRequired: boolean = false,
  accept?: string
) => action(FileDownloadActions.Download, { url, fallbackName, authRequired, accept });
export const downloadFailure = (error: IError) =>
  action(FileDownloadActions.DownloadFailure, error);
export const downloadSuccess = (response: AxiosResponse, fallbackName: string) =>
  action(FileDownloadActions.DownloadSuccess, { response, fallbackName });

const actionCreators = {
  download,
  downloadFailure,
  downloadSuccess,
};

export type FileDownloadActionType = ActionType<typeof actionCreators>;
